import React from 'react';
import moment from 'moment';
import { Stack, RadioGroup } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LinkIcon from '@mui/icons-material/Link';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentMethodOption from './PaymentMethodOption.react';
import { PAYMENT_TYPE } from '../const';
import { getBankTransferDeadline, isBankTransferAvailable } from '@/utils/PayLater';
import { isAccountBooking } from '@/utils/AccountBankTransfer';
import { useTranslation } from 'react-i18next';

const PaymentMethodGroup = ({ value, onChange, booking, isMultiMode, profile }) => {
	const { t } = useTranslation();

	const handleChange = (val) => onChange(val);

	// Account bookings settle by bank transfer only, with no deadline window.
	const isAccount = isAccountBooking(booking);
	const bankTransferAvailable = isAccount || isBankTransferAvailable(profile, booking);
	const deadlineText = bankTransferAvailable && !isAccount
		? moment(getBankTransferDeadline(booking)).format('D/M/YYYY')
		: null;

	return (
		<RadioGroup value={value} onChange={(e) => handleChange(e.target.value)}>
			<Stack spacing={1.5}>
				{!isAccount && (
					<PaymentMethodOption
						value={PAYMENT_TYPE.CREDIT_CARD}
						selected={value === PAYMENT_TYPE.CREDIT_CARD}
						onChange={handleChange}
						disabled={isMultiMode}
						title={t('Bookings.SettlePayment.CreditCard')}
						subtitle={isMultiMode ? t('Bookings.SettlePayment.NotAvailableMultiMode') : undefined}
						RightIcon={CreditCardIcon}
					/>
				)}

				{!isAccount && (
					<PaymentMethodOption
						value={PAYMENT_TYPE.SEND_PAY_LATER_LINK}
						selected={value === PAYMENT_TYPE.SEND_PAY_LATER_LINK}
						onChange={handleChange}
						disabled={isMultiMode}
						title={t('Bookings.SettlePayment.SendAPaymentLink')}
						subtitle={isMultiMode ? t('Bookings.SettlePayment.NotAvailableMultiMode') : undefined}
						RightIcon={LinkIcon}
					/>
				)}

				{bankTransferAvailable && (
					<PaymentMethodOption
						value={PAYMENT_TYPE.BANK_TRANSFER}
						selected={value === PAYMENT_TYPE.BANK_TRANSFER}
						onChange={handleChange}
						title={t('Bookings.SettlePayment.BankTransfer')}
						subtitle={
							isAccount
								? undefined
								: t('Bookings.SettlePayment.AvailableForTransfersUntil', { date: deadlineText })
						}
						RightIcon={AccountBalanceIcon}
					/>
				)}

				{/*<PaymentMethodOption*/}
				{/*	title={t('Bookings.SettlePayment.SplitPayments')}*/}
				{/*	RightIcon={DoNotDisturbOnOutlinedIcon}*/}
				{/*	disabled*/}
				{/*/>*/}
			</Stack>
		</RadioGroup>
	);
};

export default PaymentMethodGroup;
